<template>
    <div>
        <div class="overflow">
            <div class="list">
                <div class="item" v-for="(item,i) in childList" :key="i" @click.prevent="clickBill(item)">
                    <div class="flex">
                        <div class="text-gray2">
                            <span style="font-size: 16px" class="text-gray1">{{item.student_name | hideName}}</span><br>
                            <span style="font-size: 12px" class="text">{{item.student_id_number | hideId}}</span>
                        </div>
                        <div class="school">
                            <span>{{item.school_name}}</span>
                            <span class="text">{{item.class_name}}{{item.seat_number}}</span>
                        </div>
                    </div>
                    <div class="agree-label">
                        <input type="checkbox" :id="item.student_id_number" v-model="item.checked">
                        <label :for="item.student_id_number"></label>
                    </div>
                </div>
            </div>
        </div>
        <div class="bottom-div">
            <button class="btn btn-primary" @click="saveBinding" :disabled="bindingBtnDisabled">綁定親子關係</button>
        </div>
        <div v-show="dialog">
            <div class="dialog">
                <div class="img-box"><img src="../../assets/images/cashback2021/iconCheckGreen@3x.png" /></div>
                <div class="dialog-text">
                綁定成功
                </div>        
            </div>
            <div class="dialog-mask"></div>
            </div>
        </div>
    </div>    
</template>
<script>
import { queryCityChildBinding, saveCityChildBinding, queryCityChildRelation } from '../../api/api'
import { mapActions, mapGetters } from 'vuex';

export default {
    name: 'new-taipei-city-parent-child-add-list',
    data () {
        return {
            dialog: false,
            cityName: '',
            childList: [],
            bindingList: []
        }
    },
    created () {
        this.cityName = this.$route.query.city_name;
        this.childList.push(this.studentInformation);
        this.childList.forEach(el => {
            this.$set(el, 'checked', false)
        });
    },
    computed: {
        ...mapGetters(['studentInformation']),
        bindingBtnDisabled () {
            return !this.bindingList.length;
        }
    },
    filters: {
        hideName (value) {
            let first = value.substr(0, 1);
            let last = value.substr(-1, 1);
            let hide = '';
            for (let i = 0; i < (value.length - 2); i++) {
                hide += 'O';
            }
            return `${first}${hide}${last}`;
        },
        hideId (value) {
            let first = value.substr(0, 3);
            let last = value.substr(6, 4);
            let hide = '';
            for (let i = 0; i < (value.length - 7); i++) {
                hide += '*';
            }
            return `${first}${hide}${last}`;
        }
    },
    methods: {
        clickBill (item) {
            item.checked = !item.checked
            if (item.checked) {
                this.bindingList.push(item.student_id_number);
            } else {
                this.bindingList.splice(this.bindingList.findIndex(i => i === item.student_id_number), 1);
            }
        },
        saveBinding () {
            saveCityChildBinding(this.cityName, this.studentInformation.student_sid).then(res => {
                if (res.error) {
                    alert(res.error.message);
                } else {
                    this.dialog = true;
                    setTimeout(() => {
                        this.dialog = false;
                        this.$router.back();
                    }, 1500);
                }
            })

        }
    }
}
</script>
<style scoped type="text/scss" lang="scss">
html, body {
    overflow: hidden;
    background: #FFF !important;
}

.dark-card {
    margin: 20pt;
    padding: 24pt;
}

.dark-card .main {
    font-size: 20px;
}

.list {
    position: relative;
    min-height: 45vh;
}

.text {
    font-family: PingFangTC-Regular;
}

.list .item {
    background: #FFF;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 15pt 0 15pt;
    font-size: 16px;
    margin-bottom: 0;
}

.list .item:last-child {
    margin-bottom: 0;
}


.item .flex {
    display: flex;
    align-items: center;
    width: calc(100% - 50px);
    justify-content: inherit;
    padding: 10pt 0;

    .school {
        display: flex;
        text-align: right;
        flex-direction: column;
    }
}

.item:not(:last-child) .flex {
    border-bottom: 1px solid rgba(64, 64, 64, 0.1);
}

.overflow {
    background: #f9f9f9;
    overflow-y: auto;
    min-height: 80%;
    /*margin-bottom: 172pt;*/
    position: relative;
    padding-bottom: 182pt;
    width: 100%;
    bottom: 20pt;
    top: 0;
    left: 0;
    right: 0;
    -webkit-overflow-scrolling: touch;
}

.bottom-div {
    position: fixed;
    z-index: 10;
    background: #FFF;
    padding: 15px 20px 30px 20px;
    bottom: 0;
    left: 0;
    right: 0;
    font-size: 14px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .description {
        margin-bottom: 16pt;

    }
}

.dialog {
  z-index: 99;
  background-color: #fff;
  padding: 24pt 20pt;
  border-radius: 16pt;
  position: fixed;
  top: 50%;
  transform: translate(0, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 30%;

  .img-box {
    padding: 0 20pt 16pt 20pt;

    img {
      width: 48pt;
      height: 48pt;
    }
  }

  .dialog-text {
    text-align: center;
    font-size: 18px;
  }
}
</style>
